import React, {FC, useState} from 'react';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';

import {PlusIcon} from 'features/menu/helpers/icons/plus/plus';
import flags from 'constants/flags/flags';

import s from './collapse.scss';

type PropsType = {
    content: string;
    onOpen?: () => void;
};

/**
 * Collapse component for menu
 *
 * @param {PropsType} props - component props
 * @returns {FC} - component
 */
export const Collapse: FC<PropsType> = ({children, content, onOpen}) => {
    const [visible, setVisible] = useState(false);

    const switchVisibility = () => {
        if (!visible && onOpen) onOpen();
        setVisible(!visible);
    };

    const isClearance = content === 'Clearance';

    return (
        <div className={s.collapse}>
            <div
                role="button"
                className={classNames(s.title, {[s.active]: visible})}
                onClick={switchVisibility}
            >
                {isClearance ? (
                    <span className={s.red}>
                        {flags.expMenuClearanceVsSaleM.isEnabled() ? 'Sale' : content}
                    </span>
                ) : (
                    content
                )}
                <PlusIcon isActive={visible} isClearance={isClearance} />
            </div>
            <AnimateHeight
                height={visible ? 'auto' : 0}
                className={s.wrapper}
                contentClassName={s.content}
            >
                {children}
            </AnimateHeight>
        </div>
    );
};
